import "babel-polyfill";
import "url-search-params-polyfill";

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
import Clipboard from "v-clipboard";
Vue.use(Clipboard);

import "@/assets/font/font.css";

Vue.config.productionTip = false;

//v-loading

import toast from "../src/components/toast";
Vue.use(toast);
import apexToast from "./components/apexToast";
Vue.use(apexToast);



import * as gf from "./globalFunc";
Vue.prototype.$gf = gf;

import "./filters";

import router from "./router";
import i18n from "./i18n";

import "@/icons";

import { NotFoundImg } from "./constant";
import VueLazyload from "vue-lazyload"; //引入这个懒加载插件
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  loading: NotFoundImg,
  error: NotFoundImg,
});

import InfoModal from "./components/modal/InfoModal";
Vue.component("InfoModal", InfoModal);


import VueClipboard from "vue-clipboard2"; //复制到粘贴板插件
// import './registerServiceWorker'
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);



// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.register("/service-worker.js");
// }

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

//Vue.component('v-select', vSelect)

